import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SuggestAnEdit from './SuggestAnEdit';
// import UploadImage from './ImageUpload';

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    // borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

class GiveATipsDialog extends React.Component {
  state = {
    open: true,
    eateryStatus: false,
    fullWidth: true,
    maxWidth: 'md',
    textAreaVal: '1. ',
    counter: 2,
    text: `1. `,
    tipsArray: [],
    openDialog2: false,
  };
  editTextArea = value => {
    this.setState({ textAreaVal: value });
  };
  _onKeyDown = e => {
    // console.log(e.keyCode);
    if (e.keyCode === 13) {
      // console.log(this.refs.text.value);
      this.state.tipsArray.push(this.refs.text.value);
      let newCounter = this.state.counter;
      this.setState({
        counter: newCounter + 1,
      });
      this.refs.text.value = `${this.refs.text.value}\n${this.state.counter}. `;
      // console.log(this.state.counter);
      e.preventDefault();
      e.stopPropagation();
    }
  };
  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({ openDialog2: true, open: false });
    if (this.props.handleClose && typeof this.props.handleClose == 'function') {
      this.props.handleClose();
    }
  };
  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  uploadImage = e => {
    var file = e.target.files[0];
    this.setState({ file, url: URL.createObjectURL(file) });
    console.log(file);
  };
  continue = e => {
    e.preventDefault();
    this.props.nextStep();
    //this.setState({ openDialog2: true });
  };

  render() {
    const title = this.props.eateryData ? this.props.eateryData.name : '';
    return (
      <div>
        {/* {this.state.tipsArray.map((item, id) => {
          return (
            <ul key={id}>
              <li>{item}</li>
            </ul>
          );
        })}
        */}
        <Dialog
          fullScreen
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            {title}
          </DialogTitle>
          <DialogContent>
            <Typography component="h4" variant="subtitle1">
              Add your tips:
            </Typography>
            <br />
            <br />
            <div>
              <textarea
                ref="text"
                autoFocus
                className="proposal-textarea"
                wrap="hard"
                defaultValue={this.state.textAreaVal}
                onChange={this.editTextArea}
                onKeyDown={this._onKeyDown}
                rows={15}
                cols={39}
                style={{
                  width: '100%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  padding: '10px',
                }}
              />
            </div>
            <div>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.eateryStatus}
                        onChange={this.handleChange('eateryStatus')}
                        value="eateryStatus"
                        // style={{ marginLeft: '24px' }}
                      />
                    }
                    label="Check if eatery is closed"
                  />
                </FormGroup>
                <input
                  accept="image/*"
                  ref={instance => (this.upload = instance)}
                  onChange={this.uploadImage}
                  type="file"
                  hidden
                  multiple
                />
                <Button
                  style={{ color: 'blue' }}
                  variant="outlined"
                  onClick={() => this.upload.click()}
                >
                  Upload Photos
                </Button>
                <br />
                {this.state.file ? <div>{this.state.file.name}</div> : null}
              </FormControl>
            </div>
          </DialogContent>
          <Grid container spacing={32}>
            <Grid item>
              <DialogActions>
                <Button
                  variant="contained"
                  color="secondary"
                  // style={{ position: 'relative', left: '16px' }}
                  onClick={() =>
                    alert('Thanks! for the tips, Will update soon!')
                  }
                >
                  Submit
                </Button>
              </DialogActions>
            </Grid>
            <Grid item>
              <DialogActions>
                {/* <Button onClick={this.handleClose} color="primary"> */}
                <Button onClick={this.continue} color="primary">
                  Suggest an Edit
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
        </Dialog>
        {this.state.openDialog2 === true ? <SuggestAnEdit /> : null}
      </div>
    );
  }
}

export default GiveATipsDialog;
